export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const FILTRO_FECHA = 'FILTRO_FECHA';
export const GET_ALL_INTEGRATOR_SYSTEM ='GET_ALL_INTEGRATOR_SYSTEM';
export const SELECCIONAR_GRAFICO = 'SELECCIONAR_GRAFICO';

export const OBTENER_DOWNLINK = "OBTENER_DOWNLINK";
export const DOWNLINK_ERROR = "DOWNLINK_ERROR";
export const DOWNLINK_OK = "DOWNLINK_OK";
export const ENVIAR_MENSAJE = "ENVIAR_MENSAJE"

export const MOSTRAR_ALERTA = "MOSTRAR_ALERTA";
export const OCULTAR_ALERTA = "OCULTAR_ALERTA";

export const CURRENT_PAGE = "CURRENT_PAGE";
export const CHANGE_PAGE = "CHANGE_PAGE";

export const REGISTRO_EXITOSO = "REGISTRO_EXITOSO";
export const REGISTRO_ERROR = "REGISTRO_ERROR";
export const OBTENER_USUARIO = "OBTENER_USUARIO";
export const PERFIL_OK = "PERFIL_OK";
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CERRAR_SESION = "CERRAR_SESION";
export const EDITAR_PERFIL = "EDITAR_PERFIL";
export const RECUPERO_CLAVE = "RECUPERO_CLAVE";
export const RECUPERO_OK = "RECUPERO_OK";
export const REESTABLECER_CLAVE = "REESTABLECER_CLAVE";
export const ACTUALIZAR_CLAVE = "ACTUALIZAR_CLAVE";

export const OBTENER_PAISES = "OBTENER_PAISES";
export const AGREGAR_PAIS = "AGREGAR_PAIS";
export const ELIMINAR_PAIS = "ELIMINAR_PAIS";
export const ACTUALIZAR_PAIS = "ACTUALIZAR_PAIS";
export const PAIS_ERROR = "PAIS_ERROR";
export const PAIS_ACTUAL = "PAIS_ACTUAL";
export const PAIS_OK = "PAIS_OK";

export const OBTENER_PROVINCIAS = "OBTENER_PROVINCIAS";
export const AGREGAR_PROVINCIA = "AGREGAR_PROVINCIA";
export const ELIMINAR_PROVINCIA = "ELIMINAR_PROVINCIA";
export const ACTUALIZAR_PROVINCIA = "ACTUALIZAR_PROVINCIA";
export const PROVINCIA_ERROR = "PROVINCIA_ERROR";
export const PROVINCIA_OK = "PROVINCIA_OK";
export const PROVINCIA_ACTUAL = "PROVINCIA_ACTUAL";
export const OBTENER_PROVINCIA = "OBTENER_PROVINCIA";
export const LIMPIAR_PROVINCIA = "LIMPIAR_PROVINCIA";

export const OBTENER_LOCALIDADES = "OBTENER_LOCALIDADES";
export const AGREGAR_LOCALIDAD = "AGREGAR_LOCALIDAD";
export const ELIMINAR_LOCALIDAD = "ELIMINAR_LOCALIDAD";
export const ACTUALIZAR_LOCALIDAD = "ACTUALIZAR_LOCALIDAD";
export const LOCALIDAD_ERROR = "LOCALIDAD_ERROR";
export const LOCALIDAD_OK = "LOCALIDAD_OK";
export const LOCALIDAD_ACTUAL = "LOCALIDAD_ACTUAL";
export const OBTENER_LOCALIDAD = "OBTENER_LOCALIDAD";
export const LIMPIAR_LOCALIDADES = "LIMPIAR_LOCALIDADES";

export const OBTENER_CLIENTES = "OBTENER_CLIENTES";
export const OBTENER_CLIENTE = "OBTENER_CLIENTE"
export const AGREGAR_CLIENTE = "AGREGAR_CLIENTE";
export const ELIMINAR_CLIENTE = "ELIMINAR_CLIENTE";
export const ACTUALIZAR_CLIENTE = "ACTUALIZAR_CLIENTE";
export const ROL_CLIENTE = "ROL_CLIENTE";
export const ELIMINAR_ROL_CLIENTE = "ELIMINAR_ROL_CLIENTE";
export const CLIENTE_ERROR = "CLIENTE_ERROR";
export const OBTENER_CLIENTES_SOPORTE = "OBTENER_CLIENTES_SOPORTE";
export const CLIENTE_OK = "CLIENTE_OK";
export const CLIENTE_ACTUAL = "CLIENTE_ACTUAL";
export const OBTENER_ROLES = "OBTENER_ROLES";

export const OBTENER_DISPOSITIVOS = "OBTENER_DISPOSITIVOS";
export const AGREGAR_DISPOSITIVO = "AGREGAR_DISPOSITIVO";
export const ELIMINAR_DISPOSITIVO = "ELIMINAR_DISPOSITIVO";
export const ACTUALIZAR_DISPOSITIVO = "ACTUALIZAR_DISPOSITIVO";
export const DISPOSITIVO_ERROR = "DISPOSITIVO_ERROR";
export const DISPOSITIVO_OK = "DISPOSITIVO_OK";
export const DISPOSITIVO_ACTUAL = "DISPOSITIVO_ACTUAL";
export const OBTENER_DISPOSITIVO = "OBTENER_DISPOSITIVO";
export const OBTENER_DISPOSITIVOS_SUPERVISADOS = "OBTENER_DISPOSITIVOS_SUPERVISADOS";
export const OBTENER_DISPOSITIVOS_POLICIA_SUPERVISADOS = "OBTENER_DISPOSITIVOS_POLICIA_SUPERVISADOS";
export const OBTENER_VARIABLES = "OBTENER_VARIABLES";
export const AGREGAR_VARIABLE = "AGREGAR_VARIABLE";
export const ELIMINAR_VARIABLE = "ELIMINAR_VARIABLE";
export const ACTUALIZAR_VARIABLE = "ACTUALIZAR_VARIABLE";
export const VARIABLE_ERROR = "VARIABLE_ERROR";
export const VARIABLE_OK = "VARIABLE_OK";
export const VARIABLE_ACTUAL = "VARIABLE_ACTUAL";
export const OBTENER_VARIABLE = "OBTENER_VARIABLE";
export const OBTENER_VARIABLE_TABLA = "OBTENER_VARIABLE_TABLA";

export const LIMPIAR_REGISTROS = "LIMPIAR_REGISTROS";
export const OBTENER_REGISTROS_HISTORICO = "OBTENER_REGISTROS_HISTORICO";
export const LIMPIAR_REGISTROS_HISTORICO = "LIMPIAR_REGISTROS_HISTORICO";
export const OBTENER_REGISTROS = "OBTENER_REGISTROS";
export const OBTENER_ULT_REGISTRO = "OBTENER_ULT_REGISTRO";
export const REGISTROS_ERROR = "REGISTROS_ERROR";
export const ACTUALIZAR_FECHAS = "ACTUALIZAR_FECHAS";

export const OBTENER_WIDGETS = "OBTENER_WIDGETS";
export const AGREGAR_WIDGET = "AGREGAR_WIDGET";
export const ELIMINAR_WIDGET = "ELIMINAR_WIDGET";
export const ACTUALIZAR_WIDGET = "ACTUALIZAR_WIDGET";
export const WIDGET_ERROR = "WIDGET_ERROR";
export const WIDGET_OK = "WIDGET_OK";
export const WIDGET_ACTUAL = "WIDGET_ACTUAL";
export const OBTENER_WIDGET = "OBTENER_WIDGET";

export const OBTENER_MARCAS = "OBTENER_MARCAS";
export const AGREGAR_MARCA = "AGREGAR_MARCA";
export const ELIMINAR_MARCA = "ELIMINAR_MARCA";
export const ACTUALIZAR_MARCA = "ACTUALIZAR_MARCA";
export const MARCA_ERROR = "MARCA_ERROR";
export const MARCA_OK = "MARCA_OK";
export const MARCA_ACTUAL = "MARCA_ACTUAL";
export const OBTENER_MARCA = "OBTENER_MARCA";

export const OBTENER_GRUPOS = "OBTENER_GRUPOS";
export const AGREGAR_GRUPO = "AGREGAR_GRUPO";
export const ELIMINAR_GRUPO = "ELIMINAR_GRUPO";
export const ACTUALIZAR_GRUPO = "ACTUALIZAR_GRUPO";
export const GRUPO_ERROR = "GRUPO_ERROR";
export const GRUPO_OK = "GRUPO_OK";
export const GRUPO_ACTUAL = "GRUPO_ACTUAL";
export const OBTENER_GRUPO = "OBTENER_GRUPO";
export const MI_ORGANIZACION = "MI_ORGANIZACION";

export const OBTENER_SUBGRUPOS = "OBTENER_SUBGRUPOS";
export const AGREGAR_SUBGRUPO = "AGREGAR_SUBGRUPO";
export const ELIMINAR_SUBGRUPO = "ELIMINAR_SUBGRUPO";
export const ACTUALIZAR_SUBGRUPO = "ACTUALIZAR_SUBGRUPO";
export const SUBGRUPO_ERROR = "SUBGRUPO_ERROR";
export const SUBGRUPO_OK = "SUBGRUPO_OK";
export const SUBGRUPO_ACTUAL = "SUBGRUPO_ACTUAL";
export const OBTENER_SUBGRUPO = "OBTENER_SUBGRUPO";

export const OBTENER_USUARIOS = "OBTENER_USUARIOS";
export const OBTENER_USUARIOS_ROL ="OBTENER_USUARIOS_ROL";
export const AGREGAR_USUARIO = "AGREGAR_USUARIO";
export const ELIMINAR_USUARIO = "ELIMINAR_USUARIO";
export const ACTUALIZAR_USUARIO = "ACTUALIZAR_USUARIO";
export const USUARIO_ERROR = "USUARIO_ERROR";
export const USUARIO_OK = "USUARIO_OK";
export const USUARIO_ACTUAL = "USUARIO_ACTUAL";
export const OBTENER_TABLA_USUARIO = "OBTENER_TABLA_USUARIO"

export const OBTENER_LOGS = "OBTENER_LOGS";
export const ACTUALIZAR_LOG = "ACTUALIZAR_LOG";
export const LOG_ERROR = "LOG_ERROR";
export const LOG_ACTUAL = "LOG_ACTUAL";
export const OBTENER_LOG = "OBTENER_LOG";
export const LOG_OK = "LOG_OK"

export const VALIDAR_USUARIO = "VALIDAR_USUARIO";

export const IS_MOBILE = "IS_MOBILE";
export const OBTENER_MODELOS = "OBTENER_MODELOS"
export const AGREGAR_MODELO = "AGREGAR_MODELO"
export const ELIMINAR_MODELO = "ELIMINAR_MODELO"
export const ACTUALIZAR_MODELO = "ACTUALIZAR_MODELO"
export const MODELO_ERROR = "MODELO_ERROR"
export const MODELO_OK = "MODELO_OK"
export const MODELO_ACTUAL = "MODELO_ACTUAL"
export const OBTENER_MODELO = "OBTENER_MODELO"
export const SET_HOST = "SET_HOST"
export const OBTENER_DEVICE_PROFILE = "OBTENER_DEVICE_PROFILE"
export const OBTENER_APLICATIONS ="OBTENER_APLICATIONS"
export const OBTENER_DEVICE_PROFILES = "OBTENER_DEVICE_PROFILES"
export const ACTUALIZAR_DEVICE_PROFILE = "ACTUALIZAR_DEVICE_PROFILE"

export const OBTENER_APPLICATIONS = "OBTENER_APPLICATIONS"
export const OBTENER_APPLICATION = "OBTENER_APPLICATION"
export const OBTENER_INTEGRATIONS = "OBTENER_INTEGRATIONS"
export const OBTENER_SERVICE_PROFILES = "OBTENER_SERVICE_PROFILES"
export const OBTENER_SERVICE_PROFILE = "OBTENER_SERVICE_PROFILE"
export const DESACTIVAR_LOG_GATEWAY = "DESACTIVAR_LOG_GATEWAY"

export const OBTENER_USUARIOS_CLIENTE = "OBTENER_USUARIOS_CLIENTE"
export const OBTENER_CLIENTES_INTEGRADOR = "OBTENER_CLIENTES_INTEGRADOR"
export const OBTENER_SOPORTES = "OBTENER_SOPORTES"
export const OBTENER_ALERTA_GATEWAY = "OBTENER_ALERTA_GATEWAY"
export const OBTENER_ALERTASXCLIENTE = "OBTENER_ALERTASXCLIENTE"
export const OBTENER_ALERTASXDISTRITO = "OBTENER_ALERTASXDISTRITO"
export const OBTENER_ALERTASENVIADAS = "OBTENER_ALERTASENVIADAS"

export const OBTENER_DASHBOARD = "OBTENER_DASHBOARD"
export const OBTENER_HISTORICO = "OBTENER_HISTORICO"
export const HISTORICO_ERROR = "HISTORICO_ERROR";
export const HISTORICO_OK = "HISTORICO_OK";

export const OBTENER_DISPOSITIVOSDEVEUI = "OBTENER_DISPOSITIVOSDEVEUI"
export const OBTENER_DISPOSITIVOSUBICACION = "OBTENER_DISPOSITIVOSUBICACION"
export const OBTENER_DISPOSITIVOSCLIENTE = "OBTENER_DISPOSITIVOSCLIENTE"
export const OBTENER_DISPOSITIVOSMODELO = "OBTENER_DISPOSITIVOSMODELO"
export const OBTENER_DISPOSITIVOSESTADO = "OBTENER_DISPOSITIVOSESTADO"
export const OBTENER_DISPOSITVOSPAQUETES = "OBTENER_DISPOSITVOSPAQUETES"
export const OBTENER_DISPOSITVOSPAQUETESPERDIDOS = "OBTENER_DISPOSITVOSPAQUETESPERDIDOS"

export const OBTENER_ESTADO_SOPORTE = "OBTENER_ESTADO_SOPORTE"
export const OBTENER_ALERTAS_VISTAS = "OBTENER_ALERTAS_VISTAS"
export const OBTENER_CANTIDAD_ALERTAS = "OBTENER_CANTIDAD_ALERTAS"

export const OBTENER_TERMINOS_Y_CONDICIONES = "OBTENER_TERMINOS_Y_CONDICIONES"
export const OBTENER_POLITICAS_DE_PRIVACIDAD = "OBTENER_POLITICAS_DE_PRIVACIDAD"
export const ACEPTAR_TERMINOS_Y_CONDICIONES = "ACEPTAR_TERMINOS_Y_CONDICIONES"
export const ACEPTAR_POLITICAS_DE_PRIVACIDAD = "ACEPTAR_POLITICAS_DE_PRIVACIDAD"
export const OBTENER_TERMINOS_ACEPTADOS = "OBTENER_TERMINOS_ACEPTADOS"
export const OBTENER_POLITICAS_ACEPTADAS = "OBTENER_POLITICAS_ACEPTADAS"
export const OBTENER_TERMINOS_Y_CONDICIONES_HISTORICO = "OBTENER_TERMINOS_Y_CONDICIONES_HISTORICO"
export const PROGRESS = "PROGRESS"

export const ALERTA_DISPOSITIVO_CLEAR_OK = "ALERTA_DISPOSITIVO_CLEAR_OK"
export const ALERTA_DISPOSITIVO_ERROR = "ALERTA_DISPOSITIVO_ERROR"
export const OBTENER_ALERTAS_DISPOSITIVO = "OBTENER_ALERTAS_DISPOSITIVO"
export const ALERTA_OK = "ALERTA_OK"